import { Box, Stack, Typography, useTheme } from "@mui/material";
import { Calculator } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const RentDisclaimer: FC = () => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			direction="row"
			alignItems="flex-start"
			gap={1}
			px={1.5}
			py={1}
			bgcolor={theme.palette.surface.muted}
			borderRadius={theme.radii.md}
		>
			<Box mt="2px" flexShrink={0} component="span" lineHeight={0}>
				<Calculator size={14} color={theme.palette.grey[400]} />
			</Box>
			<Typography
				variant="caption"
				color={theme.palette.grey[500]}
				lineHeight={1.6}
			>
				{t(Resources.Goals.Detail.RentPlan.disclaimer)}
			</Typography>
		</Stack>
	);
};
